import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Container, Card, CardBody, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import {
  formatDate,
  getRecords,
  saveRecords,
} from "../../../services/api.service.js";
import "react-toastify/dist/ReactToastify.css";
import useCreateForm from "../../../custom/Utils/UseCreateFormUtils.js";
import { createPageData, basicFormData } from "./ItemIntakeFile.js";
import {
  formContentContainer,
  loaderOverlay,
} from "../../../Style/loaderOverly.js";
import { AvForm } from "availity-reactstrap-validation";
import { LoaderCreatePage } from "../../Loader/Loader.js";
import formatDateTime from "../../../custom/Utils/formatDateTime.js";

const ItemIntakeView = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, getEndpoint } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [fetchedData, setFetchedData] = useState(null);

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  const getEditData = async (id) => {
    try {
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        include: initialPayload?.include,
      };
      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFormData({ inputData: data });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Item Intakes Details</h5>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>Intake No: </strong>
                                {formData?.inputData?.intake_no || "-"}
                              </p>
                              <p>
                                <strong>Item Description: </strong>
                                {formData?.inputData?.material?.descriptions ||
                                  "-"}
                              </p>
                              <p>
                                <strong>GMDS Code: </strong>
                                {formData?.inputData?.material?.gmds_code ||
                                  formData?.inputData?.material?.name ||
                                  "-"}
                              </p>
                              <p>
                                <strong>Item Serial No: </strong>
                                {formData?.inputData?.material_serial_no || "-"}
                              </p>

                              <p>
                                <strong>Issue Descriptions: </strong>
                                {formData?.inputData?.issue_descriptions || "-"}
                              </p>

                              <p>
                                <strong>Assigned Engineer: </strong>
                                {formData?.inputData?.job_cards?.[0]?.technician
                                  .full_name || "-"}
                              </p>
                              <p>
                                <strong>Issue Descriptions: </strong>
                                {formData?.inputData?.issue_descriptions || "-"}
                              </p>
                              <p>
                                <strong>Is Repairable: </strong>
                                {formData?.inputData?.is_repairable == null
                                  ? "-"
                                  : formData?.inputData?.is_repairable
                                    ? "Yes"
                                    : "No"}
                              </p>
                              <p>
                                <strong>Items Matching Invoice: </strong>
                                {formData?.inputData?.items_matching_invoice ==
                                null
                                  ? "-"
                                  : formData?.inputData?.items_matching_invoice
                                    ? "Yes"
                                    : "No"}{" "}
                              </p>
                              <p>
                                <strong>Comments: </strong>
                                {formData?.inputData?.comments || "-"}
                              </p>
                              <p>
                                <strong>Anti Static Bag: </strong>
                                {formData?.inputData?.anti_static_bag == null
                                  ? "-"
                                  : formData?.inputData?.anti_static_bag
                                    ? "Yes"
                                    : "No"}{" "}
                              </p>
                            </Col>

                            {/* Second Section (Right Side) */}
                            <Col md="6" className="p-3">
                              <p>
                                <strong>Fault Tag Attached: </strong>
                                {formData?.inputData?.fault_tag_attached == null
                                  ? "-"
                                  : formData?.inputData?.fault_tag_attached
                                    ? "Yes"
                                    : "No"}{" "}
                              </p>
                              <p>
                                <strong>Fault Reported From Field: </strong>
                                {formData?.inputData
                                  ?.fault_reported_from_field || "-"}
                              </p>

                              <p>
                                <strong>Rate Per Unit: </strong>
                                {formData?.inputData?.rate_per_unit || "-"}
                              </p>
                              <p>
                                <strong>Received By: </strong>
                                {formData?.inputData?.received_by_user
                                  ?.first_name || "-"}{" "}
                                {formData?.inputData?.received_by_user
                                  ?.last_name || "-"}
                              </p>
                              <p>
                                <strong>Received At: </strong>
                                {!formData?.inputData?.received_date ||
                                loadingData
                                  ? "-"
                                  : formatDate(
                                      formData?.inputData?.received_date,
                                    )}
                              </p>

                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.status || "-"}
                              </p>

                              <p>
                                <strong>Is Active: </strong>
                                {formData?.inputData?.is_active === true
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                              <p>
                                <strong>Created At: </strong>
                                {!formData?.inputData?.createdAt || loadingData
                                  ? "-"
                                  : formatDateTime(
                                      formData?.inputData?.createdAt,
                                    )}
                              </p>

                              <p>
                                <strong>Updated At: </strong>
                                {!formData?.inputData?.updatedAt || loadingData
                                  ? "-"
                                  : formatDateTime(
                                      formData?.inputData?.updatedAt,
                                    )}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </AvForm>

                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ItemIntakeView;
